// extracted by mini-css-extract-plugin
export default {"header":"style_header__63ZLI","backButton":"style_backButton__i4cCc","name":"style_name__ICDO-"};